module.exports = __webpack_public_path__ + "img/组 2150@2x.38d9ecfa.png";